var infraestructura = angular.module('infraestructuras');

infraestructura.controller('infraestructuraController', ['$rootScope', '$scope', '$location', 'infraestructurasService', '$routeParams', 'authenticationInfo', 'authenticationService', 'infraestructurasAdminService', 'inspeccionesService'
    , function ($rootScope, $scope, $location, infraestructurasService, $routeParams, authenticationInfo, authenticationService, infraestructurasAdminService, inspeccionesService) {

        $scope.authentication = authenticationInfo;
        $scope.pestanyavisible = 'general';
        $scope.pestanyamenuinspeccion = 'general';
        $scope.pestanyamenusuperior = 'informacion';
        $rootScope.InfraestructuraId = $routeParams.id;
        $scope.longitud = 1000;


        $scope.isTunelCarretero = function () {
            return $scope.infraestructura && $scope.infraestructura.CategoriaId === 1;
        };

        $scope.isTunelFerroviario = function () {
            return $scope.infraestructura && $scope.infraestructura.CategoriaId === 6;
        };

        $scope.isPresa = function () {
            return $scope.infraestructura && $scope.infraestructura.CategoriaId === 3;
        };

        if ($rootScope.parteUrl == true) {
            $scope.OpcionSeleccionada = "app/Partes/partes.html";
            $scope.OpcionSeleccionadaClass = 'parte';
            $scope.pestanyaparte = "tab-parte active"
            $scope.pestanyanube = "tab-nube"
            $rootScope.parteUrl = false;
            $rootScope.inspeccionUrl = false;
        }
        else {
            if ($rootScope.inspeccionUrl == true) {
                $scope.pestanyamenusuperior = 'inspeccion';
            }
            $scope.OpcionSeleccionada = "app/TV/TV.html";
            $scope.OpcionSeleccionadaClass = 'tv';
            $scope.pestanyaparte = "tab-parte"
            $scope.pestanyanube = "tab-nube active"
            $rootScope.inspeccionUrl = false;
            $rootScope.parteUrl = false;
        }

        $scope.idObra = $routeParams.id;

        $scope.eliminarInspeccion = function (idInspeccion) {
            check = confirm("¿Seguro que deseas eliminar esta inspección?")

            if (check) {
                inspeccionesService.eliminarInspeccion(idInspeccion)
                    .then(function (response) {
                        infraestructurasService.getInspecciones($scope.tunel.Id)
                            .then(function (response) {
                                var data = response.data;
                                $scope.inspecciones = data;
                            });
                    });
            }
        }

        infraestructurasAdminService.getEntornos()
            .then(function (response) {
                var data = response.data;
                $scope.entornos = data;
            });



        infraestructurasAdminService.getInspectores()
            .then(function (response) {
                var data = response.data;
                $scope.inspectores = data;
            });


        infraestructurasAdminService.getPropietarios()
            .then(function (response) {
                var data = response.data;
                $scope.propietarios = data;
            });

        infraestructurasAdminService.getMunicipios()
            .then(function (response) {
                var data = response.data;
                $scope.municipios = data;
            });

        infraestructurasAdminService.getRios()
            .then(function (response) {
                var data = response.data;
                $scope.rios = data;
            });

        infraestructurasAdminService.getDemarcaciones()
            .then(function (response) {
                var data = response.data;
                $scope.demarcaciones = data;
            });

        $scope.validarSeleccion = function () {
            if (!$scope.informeSeleccionado) {
                // Si no se selecciona un informe, muestra una alerta
                alert("Por favor, seleccione un informe antes de continuar.");
                return;
            }

            // Si se seleccionó un informe, procede con la generación
            $scope.imprimirInforme($scope.ultimainspeccion);
        };


        $scope.verInspeccion = function (idInspeccion) {
            $location.url('/inspecciones/' + idInspeccion);
        }

        // Variable que representa el valor del índice
        const indiceValor = 2; // Cambia este valor dinámicamente (1, 2 o 3)

        infraestructurasService.getInfraestructura($routeParams.id)
            .then(function (response) {
                var data = response.data;
                $scope.infraestructura = data;

                $scope.esTunel = ($scope.infraestructura && $scope.infraestructura.CategoriaId === 1);
                $scope.esPresa = ($scope.infraestructura && $scope.infraestructura.CategoriaId === 2);

                setTimeout(function () {
                    if (!$scope.infraestructura || !$scope.infraestructura.Tiempo) return;

                    const divTemporal = document.createElement("div");
                    divTemporal.innerHTML = $scope.infraestructura.Tiempo.toString();

                    const script = divTemporal.querySelector("script");
                    const divWidget = divTemporal.querySelector("div");

                    if (script && divWidget) {
                        const container = document.getElementById("Tiempo");
                        if (container) {
                            container.innerHTML = "";
                            container.appendChild(divWidget);

                            const newScript = document.createElement("script");
                            newScript.type = "text/javascript";
                            newScript.src = script.src;
                            document.body.appendChild(newScript);
                        }
                    }
                }, 500); // Esperamos un poco por si el HTML aún no está cargado

                //   $scope.infraestructura.FechaUltimaInspeccion = new Date(data.FechaUltimaInspeccion);

                // $scope.infraestructura.FechaUltimaInspeccion = data.FechaUltimaInspeccion;

                $scope.infraestructura.PropietarioDescripcion = data.Propietario.Descripcion;
                $scope.infraestructura.PropietarioId = data.Propietario.Id;


                indicevalor = $scope.infraestructura.IndiceInspeccionId;
                if ($scope.infraestructura.CategoriaId == 4) {
                    $scope.pestanyavisible = 'visualizacion';
                    $scope.pestanyamenusuperior = 'visualizacion';
                }


                if ($scope.infraestructura.CategoriaId == 3) {
                    $scope.pestanyavisible = 'general';
                    $scope.pestanyamenusuperior = 'inventario'
                }

                //const indiceTuboSpan = document.getElementById('indiceTubo');
                /*const indiceEstado = document.getElementById('indiceEstado');*/
                const indiceValorSpan = document.getElementById('indiceValor');
                //const IndiceValorSpan = document.getElementById('Indice');


                if ($scope.infraestructura.IndiceInspeccion.Color == "Verde") {
                    $scope.infraestructura.IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-0 row";
                    $scope.infraestructura.IndiceEstadoInfraestructura = "indice-verde";
                    /*indiceEstado.style.color = "green";*/
                    indiceValorSpan.style.color = "green";
                    //IndiceValorSpan.style.color = "green";
                    //indiceTuboSpan.style.color = "green";
                }
                else if ($scope.infraestructura.IndiceInspeccion.Color == "Amarillo") {
                    $scope.infraestructura.IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-1 row";
                    $scope.infraestructura.IndiceEstadoInfraestructura = "indice-amarillo";
                    /*indiceEstado.style.color = "orange";*/
                    indiceValorSpan.style.color = "yellow";
                    //IndiceValorSpan.style.color = "#FFEA00";
                    //indiceValorSpan.style.fontFamily = "Arial, sans - serif";
                    //IndiceValorSpan.style.fontFamily = "Arial, sans - serif";
                    //                    indiceValorSpan.style.backgroundColor = "black";
                    //indiceTuboSpan.style.color = "yellow";
                }
                else if ($scope.infraestructura.IndiceInspeccion.Color == "Naranja") {
                    $scope.infraestructura.IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-1 row";
                    $scope.infraestructura.IndiceEstadoInfraestructura = "indice-naranja";
                    /*indiceEstado.style.color = "orange";*/
                    indiceValorSpan.style.color = "darkorange";
                    //IndiceValorSpan.style.color = "darkorange";
                    //indiceTuboSpan.style.color = "orange";
                }
                else if ($scope.infraestructura.IndiceInspeccion.Color == "Rojo") {
                    $scope.infraestructura.IndiceInspeccionInfraestructura = "infraestructura-box infraestructura-status-2 row";
                    $scope.infraestructura.IndiceEstadoInfraestructura = "indice-rojo";
                    /*indiceEstado.style.color = "red";*/
                    indiceValorSpan.style.color = "red";
                    //IndiceValorSpan.style.color = "red";
                    //indiceTuboSpan.style.color = "red";
                }



                infraestructurasService.getPresa($scope.infraestructura.Id)
                    .then(function (response) {
                        var data = response.data;
                        $scope.presa = data;
                    });


                infraestructurasService.getTunel($scope.infraestructura.Id)
                    .then(function (response) {
                        var data = response.data;
                        $scope.tunel = data;


                        // Registrar el plugin
                        //Chart.register(ChartDataLabels);

                        infraestructurasService.getInspeccionesTunel($scope.tunel.Id)
                            .then(function (response) {
                                var data = response.data;
                                $scope.inspecciones = data;
                                $scope.ultimainspeccion = new Object();
                                $scope.ultimainspeccion.Id = $scope.inspecciones[0].Id;
                                $scope.ultimainspeccion.fechafin = $scope.inspecciones[0].FechaFin;
                                $scope.ultimainspeccion.fechaInicio = $scope.inspecciones[0].FechaInicio;

                                $scope.ultimainspeccion.InspectorDescripcion = $scope.inspecciones[0].Inspector.Descripcion;
                                $scope.ultimainspeccion.InspectorId = $scope.inspecciones[0].Inspector.Id;

                                $scope.ultimainspeccion.PropietarioDescripcion = $scope.inspecciones[0].Propietario.Descripcion;
                                $scope.ultimainspeccion.PropietarioId = $scope.inspecciones[0].Propietario.Id;

                                //$scope.ultimoPropietario = $scope.inspecciones[0].Propietario.Descripcion;
                                //$scope.ultimoPropietarioId = $scope.inspecciones[0].propietarioId;


                                // codigo de chatGPT

                                /*let checkInterval = setInterval(function () {*/
                                if (typeof ChartDataLabels !== 'undefined') {
                                    // Si está definido, regístralo y detén el intervalo
                                    Chart.register(ChartDataLabels);
                                    /* console.log('ChartDataLabels registrado correctamente.');*/
                                }
                                // Cancela el intervalo
                                ; // Comprueba cada 100 ms

                                infraestructurasService.getDañosPorTipo($scope.ultimainspeccion.Id)
                                    .then(function (response) {
                                        $scope.dañosportipo = response.data;

                                        // Generar dinámicamente los labels y los datos basados en $scope.daños
                                        const labels = $scope.dañosportipo.map(function (d) {
                                            return d.Tipo.Descripcion || 'N/A';
                                        });

                                        const data = $scope.dañosportipo.map(function (d) {
                                            return d.Conteo || 0;
                                        });

                                        // Generar colores dinámicamente si hay más de 3 tipos de daños
                                        const backgroundColors = labels.map(function (_, i) {
                                            return 'rgba(' +
                                                Math.floor(Math.random() * 255) + ', ' +
                                                Math.floor(Math.random() * 255) + ', ' +
                                                Math.floor(Math.random() * 255) + ', 0.7)';
                                        });

                                        const borderColors = [];
                                        for (var i = 0; i < labels.length; i++) {
                                            borderColors.push(
                                                'rgba(' +
                                                Math.floor(Math.random() * 255) + ', ' +
                                                Math.floor(Math.random() * 255) + ', ' +
                                                Math.floor(Math.random() * 255) + ', 1)'
                                            );
                                        }

                                        // Configuración de los datos del gráfico
                                        const damageData = {
                                            labels: labels, // Etiquetas dinámicas
                                            datasets: [{
                                                label: 'Distribución de Daños',
                                                data: data, // Datos dinámicos
                                                backgroundColor: backgroundColors,
                                                borderColor: borderColors,
                                                borderWidth: 1
                                            }]
                                        };

                                        // Configuración del gráfico
                                        const config = {
                                            type: 'pie',
                                            data: damageData,
                                            options: {
                                                responsive: true,
                                                plugins: {
                                                    legend: {
                                                        display: false, // Oculta la leyenda
                                                    },
                                                    tooltip: {
                                                        enabled: true, // Mostrar valores al pasar el mouse
                                                    },
                                                    datalabels: {
                                                        color: '#000', // Color del texto
                                                        font: {
                                                            size: 12, // Tamaño del texto
                                                            weight: 'bold'
                                                        },
                                                        formatter: function (value, ctx) {
                                                            // Calcula el porcentaje
                                                            const total = ctx.chart.data.datasets[0].data.reduce(function (sum, val) {
                                                                return sum + val;
                                                            }, 0);
                                                            const percentage = ((value / total) * 100).toFixed(2);
                                                            return percentage + '%'; // Devuelve el porcentaje
                                                        }
                                                    }
                                                },
                                                layout: {
                                                    padding: 20 // Añade espacio alrededor del gráfico
                                                }
                                            }
                                        };

                                        // Creación del gráfico
                                        const ctx = document.getElementById('graficoDaniosPorTipo').getContext('2d');
                                        const damagePieChart = new Chart(ctx, config);
                                    });


                                infraestructurasService.getDañosPorGravedad($scope.ultimainspeccion.Id)
                                    .then(function (response) {
                                        $scope.dañosporgravedad = response.data;
                                        $scope.daniosporgravedad = response.data;

                                        // Generar dinámicamente los labels y los datos basados en $scope.daños
                                        const labelsGr = $scope.dañosporgravedad.map(function (d) {
                                            return d.GravedadDaño || 'N/A';
                                        });

                                        const dataGr = $scope.dañosporgravedad.map(function (d) {
                                            return d.Conteo || 0;
                                        });

                                        const colorMap = {
                                            'Leve': 'rgba(0, 128, 0, 0.7)',         // Verde
                                            'Moderado': 'rgba(255, 255, 0, 0.7)',   // Amarillo
                                            'Severo': 'rgba(255, 165, 0, 0.7)',     // Naranja
                                            'Critico': 'rgba(255, 0, 0, 0.7)'       // Rojo
                                        };
                                        const darkerColorMap = {
                                            'Leve': 'rgba(0, 100, 0, 1)',           // Verde oscuro
                                            'Moderado': 'rgba(200, 200, 0, 1)',     // Amarillo oscuro
                                            'Severo': 'rgba(200, 100, 0, 1)',       // Naranja oscuro
                                            'Critico': 'rgba(150, 0, 0, 1)'         // Rojo oscuro
                                        };

                                        // Generar colores de fondo
                                        var backgroundColorsGr = labelsGr.map(function (label) {
                                            return colorMap[label];
                                        });

                                        // Generar colores de borde
                                        var borderColorsGr = labelsGr.map(function (label) {
                                            return darkerColorMap[label];
                                        });


                                        // Configuración de los datos del gráfico
                                        const damageDataGr = {
                                            labels: labelsGr, // Etiquetas dinámicas
                                            datasets: [{
                                                label: 'Distribución de Daños',
                                                data: dataGr, // Datos dinámicos
                                                backgroundColor: backgroundColorsGr,
                                                borderColor: borderColorsGr,
                                                borderWidth: 1
                                            }]
                                        };

                                        // Configuración del gráfico
                                        const configGr = {
                                            type: 'pie',
                                            data: damageDataGr,
                                            options: {
                                                responsive: true,
                                                plugins: {
                                                    legend: {
                                                        display: false, // Oculta la leyenda
                                                    },
                                                    tooltip: {
                                                        enabled: true, // Mostrar valores al pasar el mouse
                                                    },
                                                    datalabels: {
                                                        color: '#000', // Color del texto
                                                        font: {
                                                            size: 12, // Tamaño del texto
                                                            weight: 'bold'
                                                        },
                                                        formatter: function (value, ctx) {
                                                            // Calcula el porcentaje
                                                            const total = ctx.chart.data.datasets[0].data.reduce(function (sum, val) {
                                                                return sum + val;
                                                            }, 0);
                                                            const percentage = ((value / total) * 100).toFixed(2);
                                                            return percentage + '%'; // Devuelve el porcentaje
                                                        }
                                                    }
                                                },
                                                layout: {
                                                    padding: 20 // Añade espacio alrededor del gráfico
                                                }
                                            }
                                        };

                                        // Creación del gráfico
                                        const ctxGr = document.getElementById('graficoDaniosPorGravedad').getContext('2d');
                                        const damagePieChartGr = new Chart(ctxGr, configGr);
                                    });

                                infraestructurasService.getDañosPorElemento($scope.ultimainspeccion.Id)
                                    .then(function (response) {
                                        $scope.dañosporelemento = response.data;

                                        // Generar dinámicamente los labels y los datos basados en $scope.daños
                                        const labels = $scope.dañosporelemento.map(function (d) {
                                            return d.Elemento.Descripcion || 'N/A';
                                        });

                                        const data = $scope.dañosporelemento.map(function (d) {
                                            return d.Conteo || 0;
                                        });

                                        // Generar colores dinámicamente si hay más de 3 tipos de daños
                                        const backgroundColors = labels.map(function (_, i) {
                                            return 'rgba(' +
                                                Math.floor(Math.random() * 255) + ', ' +
                                                Math.floor(Math.random() * 255) + ', ' +
                                                Math.floor(Math.random() * 255) + ', 0.7)';
                                        });

                                        const borderColors = [];
                                        for (var i = 0; i < labels.length; i++) {
                                            borderColors.push(
                                                'rgba(' +
                                                Math.floor(Math.random() * 255) + ', ' +
                                                Math.floor(Math.random() * 255) + ', ' +
                                                Math.floor(Math.random() * 255) + ', 1)'
                                            );
                                        }

                                        // Configuración de los datos del gráfico
                                        const damageData = {
                                            labels: labels, // Etiquetas dinámicas
                                            datasets: [{
                                                label: 'Distribución de Daños',
                                                data: data, // Datos dinámicos
                                                backgroundColor: backgroundColors,
                                                borderColor: borderColors,
                                                borderWidth: 1
                                            }]
                                        };

                                        // Configuración del gráfico
                                        const config = {
                                            type: 'pie',
                                            data: damageData,
                                            options: {
                                                responsive: true,
                                                plugins: {
                                                    legend: {
                                                        display: false, // Oculta la leyenda
                                                    },
                                                    tooltip: {
                                                        enabled: true, // Mostrar valores al pasar el mouse
                                                    },
                                                    datalabels: {
                                                        color: '#000', // Color del texto
                                                        font: {
                                                            size: 12, // Tamaño del texto
                                                            weight: 'bold'
                                                        },
                                                        formatter: function (value, ctx) {
                                                            // Calcula el porcentaje
                                                            const total = ctx.chart.data.datasets[0].data.reduce(function (sum, val) {
                                                                return sum + val;
                                                            }, 0);
                                                            const percentage = ((value / total) * 100).toFixed(2);
                                                            return percentage + '%'; // Devuelve el porcentaje
                                                        }
                                                    }
                                                },
                                                layout: {
                                                    padding: 20 // Añade espacio alrededor del gráfico
                                                }
                                            }
                                        };

                                        // Creación del gráfico
                                        const ctx = document.getElementById('graficoDaniosPorElemento').getContext('2d');
                                        const damagePieChart = new Chart(ctx, config);
                                    });


                                infraestructurasService.getResumenPorSeccion($scope.ultimainspeccion.Id, 100)
                                    .then(function (response) {
                                        $scope.danosSeccion = response.data;
                                        $scope.longitud = $scope.danosSeccion.length;
                                    });


                                inspeccionesService.getDañosPorSeccion($scope.ultimainspeccion.Id, 100)
                                    .then(function (response) {
                                        $scope.danosSecciones = response.data;
                                    });

                            });

                    });
            });


        $scope.getColor = function (gravedad) {
            switch (gravedad) {
                case 1:
                    return "green";
                case 2:
                    return "yellow";
                case 3:
                    return "darkorange";
                case 4:
                    return "red";
                default:
                    return "#E0E0E0";
            }
        };

        $scope.getWidth = function (seccion, cantidad) {
            var total = seccion.TotalDanos || 1; // Evitar división por 0
            return (cantidad / total) * 120; // Ajusta al ancho de la sección
        };

        $scope.getOffset = function (seccion, gravedad) {
            var offset = 0;
            for (var g in seccion.DañosPorGravedad) {
                if (g == gravedad) break;
                offset += $scope.getWidth(seccion, seccion.DañosPorGravedad[g]);
            }
            return offset;
        };

        infraestructurasService.getTiposTunel()
            .then(function (response) {
                var data = response.data;
                $scope.tiposTunel = data;
            });

        infraestructurasService.getTiposPresa()
            .then(function (response) {
                var data = response.data;
                $scope.tipoPresa = data;
            });

        infraestructurasService.getformaPlanta()
            .then(function (response) {
                var data = response.data;
                $scope.formaPlanta = data;
            });

        infraestructurasService.getObstaculos()
            .then(function (response) {
                var data = response.data;
                $scope.obstaculos = data;
            });

        infraestructurasService.getNumDireccionesTunel()
            .then(function (response) {
                var data = response.data;
                $scope.numDireccionesTunel = data;
            });

        infraestructurasService.getMaterialesTunel()
            .then(function (response) {
                var data = response.data;
                $scope.materiales = data;
            });

        infraestructurasService.getMaterialesPresa()
            .then(function (response) {
                var data = response.data;
                $scope.materialesPresa = data;
            });

        infraestructurasService.getCategoriaPresa()
            .then(function (response) {
                var data = response.data;
                $scope.categoriaPresa = data;
            });

        infraestructurasService.getUsosPresa()
            .then(function (response) {
                var data = response.data;
                $scope.usosPresa = data;
            });

        infraestructurasService.getTipoVia()
            .then(function (response) {
                var data = response.data;
                $scope.tiposVia = data;
            });

        infraestructurasService.getCirculacionPermitida()
            .then(function (response) {
                var data = response.data;
                $scope.circulacionesPermitida = data;
            });

        infraestructurasService.getCategoria($rootScope.categoria)
            .then(function (response) {
                var data = response.data;
                $scope.categoria = data;
            });


        $scope.verCategorias = function () {
            $rootScope.inspeccionUrl = false;
            $rootScope.parteUrl = false;
            $location.path('/categorias');
        };



        $scope.guardarInventario = function () {

            if ($scope.esTunel) {

                if (
                    !$scope.infraestructura.CodIdentificador ||
                    !$scope.infraestructura.Propietario ||
                    !$scope.infraestructura.Propietario.Id ||
                    !$scope.infraestructura.Entorno ||
                    !$scope.infraestructura.Entorno.Id ||
                    !($scope.infraestructura.Municipio && $scope.infraestructura.Municipio.Id)
                ) {
                    alert("Debes rellenar todos los campos obligatorios antes de guardar.");
                }


                $scope.tunel.InfraestructuraId = $routeParams.id;
                $scope.tunel.AñoConstruccion = $scope.tunel.AnioConstruccion;
                $scope.tunel.MaterialHastialDcholId = $scope.tunel.MaterialHastialDchoId;
                if ($scope.tunel.Id != undefined) {
                    var formDataTunel = new FormData();
                    formDataTunel.append("tunel", JSON.stringify($scope.tunel));

                    infraestructurasService.guardarInventarioTunel($scope.tunel.Id, formDataTunel, $scope.infraestructura.CodIdentificador, $scope.infraestructura.Propietario.Id, $scope.infraestructura.Entorno.Id, $scope.infraestructura.Municipio.Id)
                        .then(function (response) {
                            var data = response.data;
                            $scope.tunel.Id = data;
                            alert("Datos guardados correctamente");
                        });
                } else {
                    $scope.tunel.Id = -1;
                    infraestructurasService.guardarInventario($scope.tunel)
                        .then(function (response) {
                            var data = response.data;
                            $scope.tunel.Id = data;
                            alert("Datos guardados correctamente");
                        });
                }
            } else if ($scope.esPresa) {

                if (
                    !$scope.infraestructura.CodIdentificador ||
                    !($scope.infraestructura.Municipio && $scope.infraestructura.Municipio.Id)
                ) {
                    alert("Debes rellenar todos los campos obligatorios antes de guardar.");
                }



                if ($scope.presa.Id != undefined) {
                    var formDataPresa = new FormData();
                    formDataPresa.append("presa", JSON.stringify($scope.presa));
                    infraestructurasService.guardarInventarioPresa($scope.presa.Id, formDataPresa, $scope.infraestructura.Nombre, $scope.infraestructura.CodIdentificador, $scope.infraestructura.Municipio.Id)
                        .then(function (response) {
                            var data = response.data;
                            $scope.presa.Id = data;
                            alert("Datos guardados correctamente");
                        });
                } else {
                    $scope.presa.Id = -1;
                    infraestructurasService.guardarInventario($scope.presa)
                        .then(function (response) {
                            var data = response.data;
                            $scope.presa.Id = data;
                            alert("Datos guardados correctamente");
                        });
                }
            }
        };


        $scope.guardarInspeccion = function () {
            infraestructurasService.guardarInspeccion($scope.inspeccion)
                .then(function (response) {
                    var data = response.data;
                    $scope.tunel.Id = data;
                    alert("Datos guardados correctamente");
                });
        };

        $scope.volver = function () {
            $location.path('/infraestructuras/' + $scope.infraestructura.CategoriaId);
        }

        $scope.getModelo = function () {
            //$location.path("/modelo/" + $routeParams.id);
            $scope.OpcionSeleccionada = "app/VisorModelos/visorModelos.html";
            $scope.OpcionSeleccionadaClass = 'modelos';
        }


        $scope.getSensores = function () {
            //$location.path("/modelo/" + $routeParams.id);
            if ($scope.infraestructura && $scope.infraestructura.CategoriaId === 3) {
                $scope.OpcionSeleccionada = "app/Sensores/mediciones.html";
            }
            else {
                $scope.OpcionSeleccionada = "app/Sensores/Sensores.html";
            }
            $scope.OpcionSeleccionadaClass = 'sensores';
        }

        $scope.nuevaInspeccion = function () {
            $location.url('/inspecciones/0');
        }

        $scope.getNubeDePuntos = function () {
            //$location.path("/TV/" + $routeParams.id);
            $scope.OpcionSeleccionada = "app/TV/TV.html";
            $scope.OpcionSeleccionadaClass = 'tv';
        }

        $scope.getGestionDocumental = function () {
            //$location.path("/TV/" + $routeParams.id);
            $scope.OpcionSeleccionada = "app/GestionDocumental/gestiondocumental.html";
            $scope.OpcionSeleccionadaClass = 'docs';
        }

        $scope.getRealidadVirtual = function () {
            //$location.path("/TV/" + $routeParams.id);
            $scope.OpcionSeleccionada = "app/TourVirtual/tourvirtual.html";
            $scope.OpcionSeleccionadaClass = 'rv';
        }


        $scope.getPartes = function () {
            $scope.OpcionSeleccionada = "app/Partes/partes.html";
            $scope.OpcionSeleccionadaClass = 'parte';
        }

        $scope.getGIS = function () {
            $scope.OpcionSeleccionada = "app/GIS/gis.html";
            $scope.OpcionSeleccionadaClass = 'gis';
        }

        $scope.logout = function () {
            //$rootScope.bodylayout = "login";
            return authenticationService.logout();
        }

        $scope.TipologiaCargar = function () {
            $scope.pestanyavisible = 'tipologia';
        }

        $scope.DimensionesCargar = function () {
            $scope.pestanyavisible = 'dimensiones';
        }

        $scope.MaterialesCargar = function () {
            $scope.pestanyavisible = 'materiales';
        }

        $scope.ImportanciaCargar = function () {
            $scope.pestanyavisible = 'importancia';
        }

        $scope.ElementosInspeccionadosCargar = function () {
            $scope.pestanyamenuinspeccion = 'elementosinspeccionados';
        }

        $scope.ElementosEvaluadosCargar = function () {
            $scope.pestanyamenuinspeccion = 'elementosevaluados';
        }

        $scope.InventarioCargar = function () {
            $scope.pestanyamenusuperior = 'inventario';
        }


        $scope.AuscultacionesCargar = function() {
            $scope.pestanyamenusuperior = 'auscultaciones';
        }


        $scope.InspeccionCargar = function () {
            $scope.pestanyamenusuperior = 'inspeccion';
        }

        $scope.ConservacionCargar = function () {
            $scope.pestanyamenusuperior = 'conservacion';
        }

        $scope.InformacionCargar = function () {
            //$scope.calcularGrafico();
            $scope.pestanyamenusuperior = 'informacion';
        }

        $scope.VisualizacionCargar = function () {
            $scope.pestanyamenusuperior = 'visualizacion';
        }

        // Funciones del tooltip
        $scope.showTooltip = function (event, seccion) {
            var tooltip = document.getElementById("tooltip");
            //var contenido = '<b>Sección:</b> ${seccion.Seccion}m<br>'
            var contenido = '';
            if (seccion.Gravedades.length > 0) {
                contenido += "<b>Daños:</b><br>";
                seccion.Gravedades.forEach(function (gravedad) {
                    var color = ""; // Variable para el color del texto
                    // Definir el color según el nivel de gravedad
                    if (gravedad.Gravedad === "Leve") {
                        color = "green";
                    } else if (gravedad.Gravedad === "Moderado") {
                        color = "#f7d547"; // Amarillo
                    } else if (gravedad.Gravedad === "Severo") {
                        color = "darkorange"; // Naranja
                    } else if (gravedad.Gravedad === "Critico") {
                        color = "red";
                    }
                    // Agregar la información con el color correspondiente
                    contenido += '<span style="color:' + color + ';">' + gravedad.Gravedad + ": " + gravedad.Conteo + "</span><br>";
                });
            } else {
                contenido += "Sin daños";
            }
            tooltip.innerHTML = contenido;
            tooltip.style.display = "block";
        };
        $scope.moveTooltip = function (event) {
            var tooltip = document.getElementById("tooltip");
            tooltip.style.left = (event.pageX + 10) + "px";
            tooltip.style.top = (event.pageY + 10) + "px";
        };
        $scope.hideTooltip = function () {
            var tooltip = document.getElementById("tooltip");
            tooltip.style.display = "none";
        };


    }]);